import type { IIEMService } from './types';
import { IEMService } from './IEMService';
export { personSizingService } from './PersonSizingService';

export const iemService: IIEMService = new IEMService();

export * from './types';
